'use strict';

var NewCalibrationCustomValidation = function NewCalibrationCustomValidation() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, element, attrs, ctrl) {
      ctrl.$parsers.unshift(function (value) {
        if (value % 60 === 0) {
          ctrl.$setValidity('travelTimeMultipleOfSixty', true);
        } else {
          ctrl.$setValidity('travelTimeMultipleOfSixty', false);
        }
        return value;
      });
    }
  };
};
NewCalibrationCustomValidation.$inject = [];
module.exports = NewCalibrationCustomValidation;